<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-06-25 17:58:52
 * @LastEditTime : 2025-06-13 10:39:28
 * @LastEditors  : yangxr
 * @Description  : 报告维护 （厂家材质、合格证）
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\reportService.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <!-- 导航 -->
          <div class="tabtop">
            <div v-for="(item, index) in navlist" :key="index" @click="choose(item.id)">
              <div :class="currenindex == index + 1 ? 'active' : 'text'">{{ item.value }}</div>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block; margin-bottom: 10px">
                  <span style="margin-right: 12px">原物料</span>
                  <el-select v-model="tableParam.rawId" placeholder="请选择" style="width: 150px" filterable>
                    <el-option v-for="(item, index) in rawDicArry" :key="index" :label="item.itemName" :value="item.id"></el-option>
                  </el-select>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">规格</span>
                  <el-select v-model="tableParam.specificationId" placeholder="请选择" style="width: 150px" filterable>
                    <el-option v-for="(item, index) in specificationArry" :key="index" :label="item.itemName" :value="item.id"></el-option>
                  </el-select>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">品牌</span>
                  <el-select v-model="tableParam.brandId" placeholder="请选择" style="width: 150px" filterable>
                    <el-option v-for="(item, index) in brandArry" :key="index" :label="item.itemName" :value="item.id"></el-option>
                  </el-select>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">报告编号</span>
                  <el-input v-model="tableParam.reportCode" style="width:150px" placeholder="请填写">
              </el-input>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div class="card_nav">
              <div>
                <el-button size="small" class="bottom_all" style="margin-left: 0" @click="rest(), addFromDate('添加')">
                  <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                  添加
                </el-button>
              </div>
              <div>
                <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                  <el-link :underline="false">
                    <span class="el-icon--left">
                      <i class="iconfont iconicon_button_filtrate"></i>
                    </span>
                    筛选
                  </el-link>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in table" :key="index">
                      <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label == '检测报告' ? (currenindex == 1 ? '材质报告' : '合格证') : item.label" align="center" :width="item.width">
                    <template slot-scope="scope">
                      <span v-if="item.label == '操作'">
                        <el-button class="bottom_one" size="mini" @click="open(scope.row)">修改</el-button>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 添加 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="760px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div>
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="fromDate" label-width="110px">
          <div>
            <el-form-item prop="companyId">
              <span slot="label">公司</span>
              <el-select
                ref="selection1"
                v-model="fromDate.companyId"
                placeholder="请选择"
                filterable
                @change="
                  $nextTick(() => {
                    fromDate.company = $refs.selection1.selectedLabel;
                  })
                "
              >
                <el-option v-for="item in companylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item prop="materialId">
            <span slot="label" style="color: #ff0000">原物料</span>
            <el-select ref="raw" v-model="fromDate.materialId" placeholder="请选择" filterable>
              <el-option
                v-for="(item, index) in rawArry"
                :key="index"
                :label="item.name + '_' + item.specification + '_' + item.manufacturer + '_' + item.originPlace"
                :value="item.id"
                @click.native="selectRaw(item)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="yearMonthTime">
            <span slot="label">年月</span>
            <el-date-picker v-model="fromDate.yearMonthTime" type="month" value-format="yyyy-MM" placeholder="选择日期时间"> </el-date-picker>
          </el-form-item>
          <el-form-item prop="reportCode">
            <span slot="label" style="color: #ff0000">报告编号</span>
            <el-input v-model="fromDate.reportCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="vender">
            <span slot="label">厂家</span>
            <el-input v-model="fromDate.vender" placeholder="请输入" clearable></el-input>
          </el-form-item>

          <el-form-item prop="dateOdProduction">
            <span slot="label">出厂日期</span>
            <el-date-picker v-model="fromDate.dateOdProduction" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
          </el-form-item>
          <el-form-item prop="checkUnit">
            <span slot="label">校验单位</span>
            <el-input v-model="fromDate.checkUnit" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="checkResult">
            <span slot="label">校验结果</span>
            <el-select v-model="fromDate.checkResult" placeholder="请选择">
              <el-option value="OK"></el-option>
              <el-option value="NG"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <span slot="label">校验报告</span>
            <FileComponent :fileCode="currenindex == 1 ? 'certificateOfApproval' : 'manufacturerMaterialReport'" action="/icps/system/sign/intelligent/report/maintain/importReportPicture" :files="listFilesa" @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="pagessubmitFromDate()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, saveOrUpdate, rawQueryPage, queryDetail } from "@/api/smart/reportService.js";
import { getDicType } from "@/api/common.js";
import FileComponent from "@/components/File/fileComponent";
import { permissionsCompanyList } from "@/api/common.js";
export default {
  components: { FileComponent },
  mixins: [mixin],
  data() {
    return {
      table: [
        { label: "原物料名称", prop: "rawName", status: true, width: "auto" },
        { label: "规格", prop: "specification", status: true, width: "220" },
        { label: "品牌", prop: "brandName", status: true, width: "auto" },
        { label: "年月", prop: "yearMonthTime", status: true, width: "200" },
        { label: "检测报告", prop: "checkReport", status: true, width: "150" },
        { label: "报告编号", prop: "reportCode", status: true, width: "auto" },
        { label: "厂家", prop: "vender", status: true, width: "auto" },
        { label: "出厂日期", prop: "dateOdProduction", status: true, width: "auto" },
        { label: "检验结果", prop: "checkResult", status: true, width: "auto" },
        { label: "检验单位", prop: "checkUnit", status: true, width: "auto" },
        { label: "操作", prop: "", status: true, width: "auto" },
      ],
      queryPage: queryPage,
      tableData: [],
      pagesType: 0,
      navlist: [
        {
          value: "厂家材质报告",
          id: 1,
        },
        {
          value: "合格证",
          id: 2,
        },
      ],
      currenindex: 1,
      specificationArry: [],
      rawArry: [], //原物料管理数据
      rawDicArry: [], //字典数据
      brandArry: [],

      /*添加*/
      companylist: [],
      fromDate: {
        type: 1,
      },
      listFilesa: [],
      rules: {
        reportCode: [{ required: true, message: "请输入报告编号", trigger: "blur" }],
        materialId: [{ required: true, message: "请选择原物料", trigger: "change" }],
        companyId: [{ required: true, message: "请选择公司", trigger: "change" }],
        yearMonthTime: [{ required: true, message: "请选择年月", trigger: "change" }],
      },
    };
  },
  watch: {},
  async created() {
    this.companylist = await permissionsCompanyList();
    this.tableParam = { ...this.tableParam, brandId: "", specificationId: "", rawId: "", type: 1,reportCode:"" };
    this.gettableData();
    getDicType({ code: "MATspec" }).then(res => {
      this.specificationArry = res.data.items; //
    });
    getDicType({ code: "MATname" }).then(res => {
      this.rawDicArry = res.data.items;
    });
    getDicType({ code: "MATbrand" }).then(res => {
      this.brandArry = res.data.items;
    });
    rawQueryPage({ page: 1, pageSize: 99999, enable: 1,isHandOver:1 }).then(res => {
      this.rawArry = res.data.data;
    });
  },
  methods: {
    selectRaw(item) {
      this.fromDate.rawName = item.name;
      this.fromDate.rawId = item.rawId;
      this.fromDate.specification = item.specification;
      this.fromDate.specificationId = item.specificationId;
      this.fromDate.brandName = item.brand;
      this.fromDate.brandId = item.brandId;
    },
    async open(low) {
      let _this = this;
      await queryDetail({ id: low.id }).then(res => {
        _this.listFilesa = [];
        let obj = {
          name: res.data.checkReport,
          fileName: res.data.checkReport,
          path: res.data.checkReportUrl,
          sourceFile: res.data.sourceFile,
          sourceFileUrl: res.data.sourceFileUrl,
        };
        _this.listFilesa.push(obj);
        this.fromDate = res.data;
        this.addDialog = true;
      });
    },
    pagessubmitFromDate() {
      let _this = this;
      _this.$refs.reffromDate.validate(valid => {
        if (valid) {
          if (_this.listFilesa.length > 0) {
            _this.fromDate.checkReport = _this.listFilesa[0].fileName;
            _this.fromDate.checkReportUrl = _this.listFilesa[0].path;
            _this.fromDate.sourceFile = _this.listFilesa[0].sourceFile;
            _this.fromDate.sourceFileUrl = _this.listFilesa[0].sourceFileUrl;
          } else {
            _this.fromDate.checkReport = "";
            _this.fromDate.checkReportUrl = "";
            _this.fromDate.sourceFile = "";
            _this.fromDate.sourceFileUrl = "";
          }
          _this.fromDate.type = _this.currenindex;
          saveOrUpdate(_this.fromDate).then(res => {
            if (res.code == 1001) {
              _this.$message.success("保存成功!");
              _this.gettableData();
              _this.addDialog = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index) {
      this.listFilesa.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      console.log(data);
      this.listFilesa = [];
      let item = {
        name: data.fileName,
        fileName: data.fileName,
        path: data.fileUrl,
        sourceFile: data.sourceFile,
        sourceFileUrl: data.sourceFileUrl,
      };
      this.listFilesa.push(item);
    },
    /**导航栏切换*/
    choose(pages) {
      this.currenindex = pages;
      this.fromDate.type = pages;
      this.tableParam.type = pages;
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam.brandId = "";
      this.tableParam.specificationId = "";
      this.tableParam.rawId = "";
      this.tableParam.reportCode = "";
      this.initData();
    },
    rest() {
      this.listFilesa = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
.tabtop {
  width: 381px;
}
</style>
